(function() {
    angular.module('GorillaBoy.services')
    .constant('SharingPermission', {
        View: 'VIEW',
        Contribute: 'CONTRIBUTE'
    })
    // TODO: Dependency on $rootScope is ugly from inside of a Service. Instead the service should expect access
    // to specific constants (e.g. HTTP_VERBS, PERMISSIONS).
    .factory('DocumentService',
        ['$rootScope',
        '$http',
        '$q',
        '$log',
        '$timeout',
        'BaseService',
        'EndpointService',
        'OrganizationService',
        'AppConstants',
        'DocumentStateService',
        'localStorageService',

        function($rootScope, $http, $q, $log, $timeout, baseService, EndpointService, OrganizationService, AppConstants, DocumentStateService, localStorageService) {

            // AppConstant bindings
            var httpMethods = AppConstants.HttpMethods,
                permissions = AppConstants.Permissions,
                FEEDBACK_VISIBILITY = AppConstants.FEEDBACK_VISIBILITY,
                ACCESS_REQUESTED_RESOURCES_FILENAME = "wd_access_requested_resources",
                LOCAL_DRAFT_COMMENTS_FILENAME = 'local_draft_comments',
                LOCAL_DRAFT_ANNOTATIONS_FILENAME = 'local_draft_annotations',
                SERVICE_ROOT = function(isNewAPI) {
                    return isNewAPI ? EndpointService.endpoint(true) + 'documents/' : EndpointService.endpoint() + 'document/';
                },
                docData = null;

            var docService = {};

            // ---
            // PRIVATE utility methods.
            // ---

            function getDocumentResourceUrl(documentId, resource) {
                return SERVICE_ROOT() + documentId + resource;
            }

            // Unwrap the application data from the API response payload
            function handleSuccess(response) {
                return response.data;
            }

            function handleErrorPassthrough(response) {
                return $q.reject(response);
            }


            // ---
            // PUBLIC methods.
            // ---


            // Object containing Reduce Functions for service calls.
            // These functions reduce multi-page results to a single page
            // Output of the reduce function should be same as any given input in the list of inputs
            // - this will ensure the same code works with paginated and full-page results.
            docService.REDUCE_FUNCTIONS = {
                reduceDescribeDocumentVersions: function(dataList) {
                    var docVersions = [];
                    for(var dataIndex = 0; dataIndex < dataList.length; dataIndex++){
                        var data = dataList[dataIndex];
                        if( !data ||
                            !data.DocumentVersions){
                            $log.error("Got Bad Data in Reducer function for DescribeDocumentVersions : " +
                                JSON.stringify(data));
                            continue;
                        }

                        $log.info("Reducer processing single page of Doc-Versions, numVersions : " +
                           data.DocumentVersions.length);

                        var versionList = data.DocumentVersions;

                        for(var versionIndex = 0; versionIndex < versionList.length; versionIndex++){
                            docVersions.push(versionList[versionIndex]);
                        }
                    }
                    var result = {};
                    result.data = angular.copy(dataList[0]);
                    result.data.DocumentVersions = docVersions;
                    result.data.Marker = "";

                    $log.info("Total Doc-Versions after reduce : " + result.data.DocumentVersions.length);

                    return result;
                }
            };


            docService.didUserRequestForThisResourceAlready = function(resId) {
                var accessRequestJson = localStorageService.get(ACCESS_REQUESTED_RESOURCES_FILENAME),
                    accessRequestObj;
                if (!accessRequestJson) {
                    return false;
                } else {
                    accessRequestObj = angular.fromJson(accessRequestJson);
                    return accessRequestObj.indexOf(resId) !== -1;
                }
            };

            docService.setResourceAsRequested = function(resId) {
                var accessRequestJson = localStorageService.get(ACCESS_REQUESTED_RESOURCES_FILENAME),
                    accessRequestObj;
                if (!accessRequestJson) {
                    accessRequestJson = '[]';
                }
                accessRequestObj = angular.fromJson(accessRequestJson);
                accessRequestObj.push(resId);
                localStorageService.set(ACCESS_REQUESTED_RESOURCES_FILENAME, accessRequestObj);
            };

            docService.translateAudio = function(documentId, versionId, outputformat) {
                var config = {
                    url: EndpointService.wopiEndpoint() + '/api/v1/documents/' + documentId + '/versions/' + versionId  + '/audio?outputformat=' + outputformat,
                    method: httpMethods.GET,

                };
                var latencyEvent = $rootScope.metricServiceInstance.newLatencyMetric("DocumentService.translateAudioRequest");
                var promise = $http(EndpointService.tokenize(config));
                promise.then(null, function(response) {
                    $rootScope.metricServiceInstance.putMetric({
                        MethodName: "DocumentService.Error." + response.status + ".translateAudioRequest",
                        MetricName: "Count",
                        Unit: "Count",
                        Values: 1
                    });
                });
                promise.finally(function() {
                    latencyEvent.stopAndEmitMetric();
                });
                return promise;
            };


            docService.submitAccessRequest = function(resourceId, messageText) {
                $log.debug("Received a request for resourceId = " + resourceId + ", with messageText >" + messageText + "<");
                docService.setResourceAsRequested(resourceId);
                var config = {
                    url: EndpointService.endpoint(true) + 'resources/' + resourceId + '/createaccess',
                    method: httpMethods.POST,
                    data: {
                        ResourceId: resourceId,
                        Reason: messageText
                    }
                };
                var latencyEvent = $rootScope.metricServiceInstance.newLatencyMetric("DocumentService.submitAccessRequest");
                var promise = $http(EndpointService.tokenize(config));
                promise.then(null, function(response) {
                    $rootScope.metricServiceInstance.putMetric({
                        MethodName: "DocumentService.Error." + response.status + ".submitAccessRequest",
                        MetricName: "Count",
                        Unit: "Count",
                        Values: 1
                    });
                });
                promise.finally(function() {
                    latencyEvent.stopAndEmitMetric();
                });
                return promise;
            };

            docService.InitiateDocumentVersionUpload = function(docId, docName, contentType, docSizeInBytes, parentFolderId, checkoutId, documentCategory, passcode) {
                var config = {
                    url: SERVICE_ROOT(true),
                    method: httpMethods.POST,
                    data: {
                        Name: docName,
                        ContentType: contentType,
                        DocumentSizeInBytes: docSizeInBytes, 
                        UploadMethod: httpMethods.PUT,
                        CheckoutId: checkoutId,
                        // DocumentCategory is an optional parameter. Currently only used to identify whether this is a note doucment or not.
                        DocumentCategory: documentCategory
                    }
                };
                // Populate docId only of supplied. If docId dosent existi, a new doc is created.
                if (docId !== null && docId !== ""){
                    config.data.Id = docId;
                }
                if(parentFolderId){
                    config.data.ParentFolderId = parentFolderId
                }

                if (passcode) {
                	config.data.Password = passcode;
                }
                
                var latencyEvent = $rootScope.metricServiceInstance.newLatencyMetric("DocumentService.InitiateDocumentVersionUpload");
                var promise = $http(EndpointService.tokenize(config));
                promise.then(null, function(response) {
                    $rootScope.metricServiceInstance.putMetric({
                        MethodName: "DocumentService.Error." + response.status + ".InitiateDocumentVersionUpload",
                        MetricName: "Count",
                        Unit: "Count",
                        Values: 1
                    });
                });
                promise.finally(function() {
                    latencyEvent.stopAndEmitMetric();
                });
                return promise;
            };

            docService.updateDocumentPermissions = function(documentId, downloadPermission) {
                var config = {
                    url: SERVICE_ROOT() + documentId,
                    method: httpMethods.PUT,
                    data: {
                        DocumentId: documentId,
                        DocumentLevelPermissions: {
                            Download: (downloadPermission === true) ? permissions.GRANTED : permissions.REVOKED,
                            Upload: (downloadPermission === true) ? permissions.GRANTED : permissions.REVOKED
                        }
                    }
                };
                var latencyEvent = $rootScope.metricServiceInstance.newLatencyMetric("DocumentService.updateDocumentPermissions");
                var promise = $http(EndpointService.tokenize(config));
                promise.then(null, function(response) {
                    $rootScope.metricServiceInstance.putMetric({
                        MethodName: "DocumentService.Error." + response.status + ".updateDocumentPermissions",
                        MetricName: "Count",
                        Unit: "Count",
                        Values: 1
                    });
                });
                promise.finally(function() {
                    latencyEvent.stopAndEmitMetric();
                });
                return promise;
            };

            docService.updateAnonymousDocumentPermissions = function(documentId, downloadPermission) {
                var config = {
                    url: SERVICE_ROOT() + documentId,
                    method: httpMethods.PUT,
                    data: {
                        DocumentId: documentId,
                        DocumentLevelPermissions: {
                        	DownloadAnonymous: (downloadPermission === true) ? permissions.GRANTED : permissions.REVOKED,
                        }
                    }
                };
                var latencyEvent = $rootScope.metricServiceInstance.newLatencyMetric("DocumentService.updateAnonymousDocumentPermissions");
                var promise = $http(EndpointService.tokenize(config));
                promise.then(null, function(response) {
                    $rootScope.metricServiceInstance.putMetric({
                        MethodName: "DocumentService.Error." + response.status + ".updateAnonymousDocumentPermissions",
                        MetricName: "Count",
                        Unit: "Count",
                        Values: 1
                    });
                });
                promise.finally(function() {
                    latencyEvent.stopAndEmitMetric();
                });
                return promise;
            };

            docService.recycleDocument = function(documentId) {
                var config = {
                    url: SERVICE_ROOT(true) + documentId,
                    method: httpMethods.PATCH,
                    data: {
                        ResourceState: 'RECYCLED'
                    }
                };
                var latencyEvent = $rootScope.metricServiceInstance.newLatencyMetric("DocumentService.recycleDocument");
                var promise = $http(EndpointService.tokenize(config));
                promise.then(null, function(response) {
                    $rootScope.metricServiceInstance.putMetric({
                        MethodName: "DocumentService.Error." + response.status + ".recycleDocument",
                        MetricName: "Count",
                        Unit: "Count",
                        Values: 1
                    });
                });
                promise.finally(function() {
                    latencyEvent.stopAndEmitMetric();
                });
                return promise;
            };

            docService.getDocumentPath = function(documentId) {
                var config = {
                    url: SERVICE_ROOT(true) + documentId + '/path',
                    method: httpMethods.GET,
                    params: {
                        fields: 'name'
                    }
                };
                var latencyEvent = $rootScope.metricServiceInstance.newLatencyMetric("DocumentService.getDocumentPath");
                var promise = $http(EndpointService.tokenize(config));
                promise.then(null, function(response) {
                    $rootScope.metricServiceInstance.putMetric({
                        MethodName: "DocumentService.Error." + response.status + ".getDocumentPath",
                        MetricName: "Count",
                        Unit: "Count",
                        Values: 1
                    });
                });
                promise.finally(function() {
                    latencyEvent.stopAndEmitMetric();
                });
                return promise;
            };

            docService.getDocumentVersion = function(documentId, versionId, passcode, anonymousCall) {
                var config = {
                    url: SERVICE_ROOT(true) + documentId + '/versions/' + versionId,
                    method: httpMethods.GET,
                    params: {
                        exclude: ['OLD_PERMISSIONS']
                    }
                };

                if (anonymousCall){
                	config.isAnonymousCall = true;
                }

                if (passcode) {
                	config.headers = {
                		Password: passcode
                	};
                }
                var latencyEvent = $rootScope.metricServiceInstance.newLatencyMetric("DocumentService.getDocumentVersion");
                var promise = $http(EndpointService.tokenize(config));
                promise.then(null, function(response) {
                    $rootScope.metricServiceInstance.putMetric({
                        MethodName: "DocumentService.Error." + response.status + ".getDocumentVersion",
                        MetricName: "Count",
                        Unit: "Count",
                        Values: 1
                    });
                });
                promise.finally(function() {
                    latencyEvent.stopAndEmitMetric();
                });
                return promise;
            };

            // get document download souce url
            docService.getDocumentVersionSource = function(documentId, versionId, passcode, isAnonymousCall) {
                var config = {
                    url: SERVICE_ROOT(true) + documentId + '/versions/' + versionId,
                    method: httpMethods.GET,
                    params: {
                        exclude: ['OLD_PERMISSIONS'],
                        fields: 'source'
                    }
                };
                //Ideally we don't have to pass config.isAnonymousCall flag to the interceptor to download the file, but
                //the GB service requires Authentication header to be unset for docs shared anonymously
                if (isAnonymousCall) {
                    config.isAnonymousCall = true;
                }
                if (passcode) {
                	config.headers = {
                		Password: passcode
                	};
                }
                var latencyEvent = $rootScope.metricServiceInstance.newLatencyMetric("DocumentService.getDocumentVersionSource");
                var promise = $http(EndpointService.tokenize(config));
                promise.then(null, function(response) {
                    $rootScope.metricServiceInstance.putMetric({
                        MethodName: "DocumentService.Error." + response.status + ".getDocumentVersionSource",
                        MetricName: "Count",
                        Unit: "Count",
                        Values: 1
                    });
                });
                promise.finally(function() {
                    latencyEvent.stopAndEmitMetric();
                });
                return promise;
            };

            // get document underlay preview url
            docService.getDocumentVersionPreview = function(documentId, versionId, passcode, anonymousCall) {
                var config = {
                    url: SERVICE_ROOT(true) + documentId + '/versions/' + versionId,
                    method: httpMethods.GET,
                    params: {
                        exclude: ['OLD_PERMISSIONS'],
                        fields: 'preview'
                    }
                };

                if (anonymousCall) {
                    config.isAnonymousCall = true;
                }

                if (passcode) {
                	config.headers = {
                	   Password: passcode
                	};
                }
                var latencyEvent = $rootScope.metricServiceInstance.newLatencyMetric("DocumentService.getDocumentVersionPreview");
                var promise = $http(EndpointService.tokenize(config));
                promise.then(null, function(response) {
                    $rootScope.metricServiceInstance.putMetric({
                        MethodName: "DocumentService.Error." + response.status + ".getDocumentVersionPreview",
                        MetricName: "Count",
                        Unit: "Count",
                        Values: 1
                    });
                });
                promise.finally(function() {
                    latencyEvent.stopAndEmitMetric();
                });
                return promise;
            };

            // get document underlay preview url
            docService.getDocumentVersionPrintUrl = function(documentId, versionId, passcode, anonymousCall) {
                var config = {
                    url: SERVICE_ROOT(true) + documentId + '/versions/' + versionId,
                    method: httpMethods.GET,
                    params: {
                        exclude: ['OLD_PERMISSIONS'],
                        fields: 'preview_embed'
                    }
                };

                if (anonymousCall) {
                	config.isAnonymousCall = true;
                }

                if (passcode) {
                	config.headers = {
                		Password: passcode
                	};
                }
                var latencyEvent = $rootScope.metricServiceInstance.newLatencyMetric("DocumentService.getDocumentVersionPrintUrl");
                var promise = $http(EndpointService.tokenize(config));
                promise.then(null, function(response) {
                    $rootScope.metricServiceInstance.putMetric({
                        MethodName: "DocumentService.Error." + response.status + ".getDocumentVersionPrintUrl",
                        MetricName: "Count",
                        Unit: "Count",
                        Values: 1
                    });
                });
                promise.finally(function() {
                    latencyEvent.stopAndEmitMetric();
                });
                return promise;
            };

            docService.updateDocumentVersion = function(documentId, versionId) {
                var config = {
                    url: SERVICE_ROOT(true) + documentId + '/versions/' + versionId,
                    method: httpMethods.PATCH,
                    data: {
                        VersionStatus: 'ACTIVE'
                    }
                };
                var latencyEvent = $rootScope.metricServiceInstance.newLatencyMetric("DocumentService.updateDocumentVersion");
                var promise = $http(EndpointService.tokenize(config));
                promise.then(null, function(response) {
                    $rootScope.metricServiceInstance.putMetric({
                        MethodName: "DocumentService.Error." + response.status + ".updateDocumentVersion",
                        MetricName: "Count",
                        Unit: "Count",
                        Values: 1
                    });
                });
                promise.finally(function() {
                    latencyEvent.stopAndEmitMetric();
                });
                return promise;
            };

            docService.deleteDocumentVersion = function(documentId, documentVersion) {
                var config = {
                    url: SERVICE_ROOT() + documentId + '/version/' + documentVersion,
                    method: httpMethods.DELETE
                };
                var latencyEvent = $rootScope.metricServiceInstance.newLatencyMetric("DocumentService.deleteDocumentVersion");
                var promise = $http(EndpointService.tokenize(config));
                promise.then(null, function(response) {
                    $rootScope.metricServiceInstance.putMetric({
                        MethodName: "DocumentService.Error." + response.status + ".deleteDocumentVersion",
                        MetricName: "Count",
                        Unit: "Count",
                        Values: 1
                    });
                });
                promise.finally(function() {
                    latencyEvent.stopAndEmitMetric();
                });
                return promise;
            };


            // Setter function for the document data response. Note that doc must be a promise object here.
            docService.setDocData = function(doc) {
                docData = doc;
            };

            docService.getDocument = function(documentId, includeDrafts, passcode, isAnonymousCall) {
                $log.debug("entered docService.getDocument documentId : " + documentId);
                var config = {
                    method: httpMethods.GET,
                    url: SERVICE_ROOT(true) + encodeURIComponent(documentId),
                    params: {
                        exclude: ['OLD_PERMISSIONS'],
                        includeDrafts : !!includeDrafts,
                    }
                };

                if (isAnonymousCall) {
                	config.isAnonymousCall = true;
                }

                if (passcode) {
                    config.headers = {
                        Password: passcode
                    };
                }
                var latencyEvent = $rootScope.metricServiceInstance.newLatencyMetric("DocumentService.getDocument");
                var promise = $http(EndpointService.tokenize(config));
                promise.catch(function(response) {
                    $rootScope.metricServiceInstance.putMetric({
                        MethodName: "DocumentService.Error." + response.status + ".getDocument",
                        MetricName: "Count",
                        Unit: "Count",
                        Values: 1
                    });
                });
                promise.finally(function() {
                    latencyEvent.stopAndEmitMetric();
                });
                return promise;
            };


            docService.updateDocumentComment = function(documentId, documentVersion, commentId, newComment) {
                var config = {
                    url: SERVICE_ROOT() + documentId + '/version/' + documentVersion + '/annotation/' + encodeURIComponent(commentId),
                    method: httpMethods.PUT,
                    data: {
                        DocumentId: documentId,
                        VersionId: documentVersion,
                        Text: newComment
                    }
                };
                var latencyEvent = $rootScope.metricServiceInstance.newLatencyMetric("DocumentService.updateDocumentComment");
                var promise = $http(EndpointService.tokenize(config));
                promise.then(null, function(response) {
                    $rootScope.metricServiceInstance.putMetric({
                        MethodName: "DocumentService.Error." + response.status + ".updateDocumentComment",
                        MetricName: "Count",
                        Unit: "Count",
                        Values: 1
                    });
                });
                promise.finally(function() {
                    latencyEvent.stopAndEmitMetric();
                });
                return promise;
            };

            docService.getDocuments = function(params) {
                var config = {
                    url: SERVICE_ROOT(),
                    method: httpMethods.GET,
                    params: params
                };
                if (config.params) {
                    config.params.exclude = ['OLD_PERMISSIONS'];
                }
                var latencyEvent = $rootScope.metricServiceInstance.newLatencyMetric("DocumentService.getDocuments");
                var promise = $http(EndpointService.tokenize(config));
                promise.then(null, function(response) {
                    $rootScope.metricServiceInstance.putMetric({
                        MethodName: "DocumentService.Error." + response.status + ".getDocuments",
                        MetricName: "Count",
                        Unit: "Count",
                        Values: 1
                    });
                });
                promise.finally(function() {
                    latencyEvent.stopAndEmitMetric();
                });
                return promise;
            };

            docService.__makeHttpCallWithRetry = function(config) {
                var maxRetryCount = AppConstants.HTTP_THROTTLE_MAX_RETRY_COUNT,
                    retryCount = 1;
                return $q(function(resolve, reject) {
                    function httpFailureHandler(response) {
                        if (retryCount <= maxRetryCount &&
                            response.status >= 500 && response.status < 600) {
                            retryCount++;
                            $log.debug("Retrying the request because of failure." + JSON.stringify(response.data));
                            $timeout(function() {
                                $http(EndpointService.tokenize(config)).then(resolve, httpFailureHandler);
                            }, AppConstants.HTTP_THROTTLE_RETRY_DELAY_IN_MILLISEC);
                        } else {
                            reject(response);
                        }
                    }
                    $http(EndpointService.tokenize(config)).then(resolve, httpFailureHandler);
                });
            };

            docService.postDocumentComment = function(commentData, notifyCollaborators, isPrivate) {
                if (!commentData || !commentData.DocumentId || !commentData.VersionId || !commentData.Text) {
                    return $q.reject('Invalid commentData object passed as param');
                }
                if (commentData.ParentId && docService.isGeneratedDraftFeedbackId(commentData.ParentId)) {
                    return $q.reject('Invalid ParentId starting with draft-feedback-')
                }

                var commentDataLocal = {
                    Text : commentData.Text,
                    Visibility: isPrivate ? FEEDBACK_VISIBILITY.PRIVATE : FEEDBACK_VISIBILITY.PUBLIC,
                    DocumentId : commentData.DocumentId,
                    VersionId : commentData.VersionId,
                    ParentId : commentData.ParentId,
                    Status: AppConstants.FeedbackTypes.FEEDBACK_TYPE_PUBLISHED,
                    NotifyCollaborators: notifyCollaborators,
                    //NotificationScope is not used on the backend
                    NotificationScope: !!notifyCollaborators ? 'CONTRIBUTORS' : 'OWNER'
                };

                var config = {
                    url: SERVICE_ROOT() + commentData.DocumentId + '/version/' + commentData.VersionId + '/comment',
                    method: httpMethods.POST,
                    data: commentDataLocal
                };
                var latencyEvent = $rootScope.metricServiceInstance.newLatencyMetric("DocumentService.postDocumentComment");
                var promise = $http(EndpointService.tokenize(config));
                promise.then(null, function(response) {
                    $rootScope.metricServiceInstance.putMetric({
                        MethodName: "DocumentService.Error." + response.status + ".postDocumentComment",
                        MetricName: "Count",
                        Unit: "Count",
                        Values: 1
                    });
                });
                promise.finally(function() {
                    latencyEvent.stopAndEmitMetric();
                });
                return promise;
            };

            docService.publishDocumentAnnotation = function(documentId, documentVersion, notifyContributors) {
                var config = {
                    url: SERVICE_ROOT() + documentId + '/version/' + documentVersion + '/annotation',
                    method: httpMethods.PUT,
                    data: {
                        DocumentId: documentId,
                        VersionId: documentVersion,
                        Status: 'PUBLISHED',
                        NotificationScope: !!notifyContributors ? 'CONTRIBUTORS' : 'OWNER'
                    }
                };
                var latencyEvent = $rootScope.metricServiceInstance.newLatencyMetric("DocumentService.publishDocumentAnnotation");
                var promise = $http(EndpointService.tokenize(config));
                promise.then(null, function(response) {
                    $rootScope.metricServiceInstance.putMetric({
                        MethodName: "DocumentService.Error." + response.status + ".publishDocumentAnnotation",
                        MetricName: "Count",
                        Unit: "Count",
                        Values: 1
                    });
                });
                promise.finally(function() {
                    latencyEvent.stopAndEmitMetric();
                });
                return promise;
            };

            docService.revokeDocumentPermission = function(documentId, permission, user) {
                var recipient = (user !== undefined) ? encodeURIComponent(user) : '';
                if (recipient == OrganizationService.ORG_USER_USERNAME) {
                    recipient = '';
                }
                var config = {
                    url: SERVICE_ROOT() + documentId + '/' + permission + '/' + recipient,
                    method: httpMethods.DELETE
                };
                var latencyEvent = $rootScope.metricServiceInstance.newLatencyMetric("DocumentService.revokeDocumentPermission");
                var promise = $http(EndpointService.tokenize(config));
                promise.then(null, function(response) {
                    $rootScope.metricServiceInstance.putMetric({
                        MethodName: "DocumentService.Error." + response.status + ".revokeDocumentPermission",
                        MetricName: "Count",
                        Unit: "Count",
                        Values: 1
                    });
                });
                promise.finally(function() {
                    latencyEvent.stopAndEmitMetric();
                });
                return promise;
            };

            docService.sendFeedbackRequest = function(documentId, collaborators, message, deadline) {
                var userIds = [],
                    userNames = [],
                    config = null;
                angular.forEach(collaborators, function(value) {
                    if (value.email === value.id) {
                        userNames.push(value.email);
                    } else {
                        userIds.push(value.id);
                    }
                });
                config = {
                    url: SERVICE_ROOT() + documentId + '/feedback_request',
                    method: httpMethods.POST,
                    data: {
                        DocumentId: documentId,
                        Message: message
                    }
                };

                if (userNames.length > 0) {
                    config.data.Usernames = userNames;
                }

                if (userIds.length > 0) {
                    config.data.UserIds = userIds;
                }

                if (deadline) {
                    config.data.FeedbackDeadline = deadline.toISOString();
                }
                var latencyEvent = $rootScope.metricServiceInstance.newLatencyMetric("DocumentService.sendFeedbackRequest");
                var promise = $http(EndpointService.tokenize(config));
                promise.then(null, function(response) {
                    $rootScope.metricServiceInstance.putMetric({
                        MethodName: "DocumentService.Error." + response.status + ".sendFeedbackRequest",
                        MetricName: "Count",
                        Unit: "Count",
                        Values: 1
                    });
                });
                promise.finally(function() {
                    latencyEvent.stopAndEmitMetric();
                });
                return promise;
            };

            docService.declineFeedbackRequest = function(documentId, user) {
                var config = {
                    method: httpMethods.DELETE,
                    url: SERVICE_ROOT() + documentId + '/feedback_request/' + user
                };
                var latencyEvent = $rootScope.metricServiceInstance.newLatencyMetric("DocumentService.declineFeedbackRequest");
                var promise = $http(EndpointService.tokenize(config));
                promise.then(null, function(response) {
                    $rootScope.metricServiceInstance.putMetric({
                        MethodName: "DocumentService.Error." + response.status + ".declineFeedbackRequest",
                        MetricName: "Count",
                        Unit: "Count",
                        Values: 1
                    });
                });
                promise.finally(function() {
                    latencyEvent.stopAndEmitMetric();
                });
                return promise;
            };

            /**
             * This method allows the sharing of a document at a organization level.
             * E.g. this is used for obtaining a URL that can be shared with other users within the organization.
             */
            docService.share = function(documentId, permission) {
                var config = {
                    method: httpMethods.POST,
                    url: SERVICE_ROOT() + documentId + '/share',
                    data: {
                        DocumentId: documentId,
                        OrganizationLevelPermission: permission
                    }
                };
                var latencyEvent = $rootScope.metricServiceInstance.newLatencyMetric("DocumentService.share");
                var promise = $http(EndpointService.tokenize(config));
                promise.then(null, function(response) {
                    $rootScope.metricServiceInstance.putMetric({
                        MethodName: "DocumentService.Error." + response.status + ".share",
                        MetricName: "Count",
                        Unit: "Count",
                        Values: 1
                    });
                });
                promise.finally(function() {
                    latencyEvent.stopAndEmitMetric();
                });
                return promise;
            };

            docService.batchGetDocument = function(documentIds) {
                var config = {
                    method: httpMethods.GET,
                    url: EndpointService.endpoint(true) + '/batch/documents?documentIds=' + encodeURIComponent(documentIds.join(','))
                };
                var latencyEvent = $rootScope.metricServiceInstance.newLatencyMetric("DocumentService.batchGetDocument");
                var promise = $http(EndpointService.tokenize(config));
                promise.then(null, function(response) {
                    $rootScope.metricServiceInstance.newCounterMetric("DocumentService.Error.batchGetDocument");
                });
                promise.finally(function() {
                    latencyEvent.stopAndEmitMetric();
                });
                return promise;
            };

            /**
             * Cancel organiation-wide sharing of a document (i.e. negates `share`).
             */
            docService.cancelShare = function(documentId) {
                var config = {
                    method: httpMethods.DELETE,
                    url: SERVICE_ROOT() + documentId + '/share'
                };
                var latencyEvent = $rootScope.metricServiceInstance.newLatencyMetric("DocumentService.cancelShare");
                var promise = $http(EndpointService.tokenize(config));
                promise.then(null, function(response) {
                    $rootScope.metricServiceInstance.putMetric({
                        MethodName: "DocumentService.Error." + response.status + ".cancelShare",
                        MetricName: "Count",
                        Unit: "Count",
                        Values: 1
                    });
                });
                promise.finally(function() {
                    latencyEvent.stopAndEmitMetric();
                });
                return promise;
            };

            /* Generate local storage feedback ID
             *   Returns:    A timestamp-based ID
             *
             *   NOTE: This is a hack until we can create a local storage ID scheme
             *           feedback, comments, and annotations
             */
            docService.generateDraftFeedbackId = function() {
                return AppConstants.DRAFT_FEEDBACKS_PREFIX + new Date().getTime();
            };

            /* Check whether the given feedbackId was generated draft ID.
             *   Returns: TRUE if it's a generated draft ID.  FALSE otherwise.
             */
            docService.isGeneratedDraftFeedbackId = function(feedbackId) {
                //Do not use String.startsWith it's not available in IE
                return feedbackId !== null && (feedbackId.indexOf(AppConstants.DRAFT_FEEDBACKS_PREFIX) === 0);
            };

            docService.callCreatePreview = function(documentId, versionId) {
                var config = {
                    url: SERVICE_ROOT(true) + documentId + '/versions/' + versionId + '/preview',
                    method: httpMethods.POST,
                };
                var latencyEvent = $rootScope.metricServiceInstance.newLatencyMetric("DocumentService.cancelShare");
                var promise = baseService.callOnce(config);
                promise.then(null, function(response) {
                    $rootScope.metricServiceInstance.putMetric({
                        MethodName: "DocumentService.Error." + response.status + ".callCreatePreview",
                        MetricName: "Count",
                        Unit: "Count",
                        Values: 1
                    });
                });
                promise.finally(function() {
                    latencyEvent.stopAndEmitMetric();
                });
                return promise;
            };

            docService.describeDocumentVersions = function (documentId, includeDrafts, marker, passcode, limit) {
                var config = {
                    method: httpMethods.GET,
                    url: SERVICE_ROOT(true) + documentId + "/versions" ,
                    params: {
                        limit: limit,
                        marker: marker,
                    }
                };
                if (includeDrafts) {
                    config.params.include = "DRAFT";
                }
                if (passcode) {
                    config.headers = {
                        Password: passcode,
                    };
                }
                var promise = $http(EndpointService.tokenize(config));
                return promise;
            };
            
            docService.describeAllDocumentVersions = function (documentId, includeDrafts, passcode) {
                var config = {
                    method: httpMethods.GET,
                    url: SERVICE_ROOT(true) + documentId + "/versions" ,
                    params: {},
                };
                if (includeDrafts) {
                    config.params.include = "DRAFT";
                }
                if (passcode) {
                    config.headers = {
                        Password: passcode,
                    };
                }
                var latencyEvent = $rootScope.metricServiceInstance.newLatencyMetric("DocumentService.describeAllDocumentVersions");
                var promise = baseService.getAllPages(config, docService.REDUCE_FUNCTIONS.reduceDescribeDocumentVersions);
                promise.catch(function(response) {
                    $rootScope.metricServiceInstance.putMetric({
                        MethodName: "DocumentService.Error." + response.status + ".describeDocumentVersionsAllPage",
                        MetricName: "Count",
                        Unit: "Count",
                        Values: 1
                    });
                });
                promise.finally(function() {
                    latencyEvent.stopAndEmitMetric();
                });
                return promise;
            };

            docService.preflightDocumentDownload = function(documentUrl, reduceTraffic) {
                var config = {
                    method: httpMethods.GET,
                    url: documentUrl,
                    headers: {
                        // 1 byte to reduce traffic since we only want to verify the response headers
                        Range: reduceTraffic ? 'bytes=0-0' : null
                    }
                };
                var promise = $http(config);
                return promise;
            };

            return docService;
        }
    ]);
}());
